import React from "react";

import { Grid } from "@material-ui/core";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import * as Nominatim from "nominatim-browser";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import * as Constants from "../../../../consts/Constants.js";
import LoadingButton from '@mui/lab/LoadingButton';
import SearchIcon from '@mui/icons-material/TravelExplore';
import Card from "@material-ui/core/Card";
import BlueMarker from "../../../../assets/images/markers/blueMarker.png";
import { Node, Coordinate } from '../../../../plas/utils/geographics/models';

import alerter from "../../../alerts/alerter"

export default function Location({ place, disable, onChange }) {
 
  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const [address, setAddress] = React.useState(place.address ? place.address : "");
  const [location, setLocation] = React.useState(place.area ? place.area.coordinate : {latitude: Constants.LATITUD_AYACUCHO, longitude: Constants.LONGITUD_AYACUCHO});
  const [searching, setSearching] = React.useState(false);

  const markerRef = React.useRef(null)
  const [map, setMap] = React.useState(null);

  const changeAddress = (event) => {
    let trimmed = event.target.value.trim();
    place.address = trimmed ? trimmed : null;
    setAddress(event.target.value);

    if (!place.area) {
      place.area = new Node();
      place.area.coordinate = location;
    }
    onChange();
  }

  const searchAddress = () => {
    setSearching(true);

    let input = place.address + ", Ayacucho, Buenos Aires, Argentina";

    return Nominatim.geocode({
        q: input,
        addressdetails: true,
    }).then((results) => {
      setSearching(false);
      if (results.length !== 0) {
        let result = results[0];
        if (map != null) 
          map.setView([result.lat, result.lon], 17);
        if (!place.area)
          place.area = new Node();

        place.area.coordinate = new Coordinate({latitude: result.lat, longitude: result.lon});
        setLocation(place.area.coordinate)
        onChange()
        alerter.showSuccess("Dirección encontrada. Puedes arrastrar el marcador para corregir la ubicación del lugar.")
      } else {
        alerter.showInfo("No se pudo encontrar la dirección, pero puedes arrastrar el marcador manualmente para indicar la ubicación del lugar.")
      }
    }).catch((error) => {
      setSearching(false);
      alerter.showInfo("Ocurrió un error al buscar la dirección, pero puedes arrastrar el marcador manualmente para indicar la ubicación del lugar.")
    });
  };

  const markerEventHandlers = {
    dragend() {
      const marker = markerRef.current
      if (marker != null) {
        place.area.coordinate = new Coordinate({latitude: marker.getLatLng().lat, longitude: marker.getLatLng().lng});
        setLocation(place.area.coordinate);
        onChange();
      }
    }
  }

  const markerIcon = new L.Icon({
      iconUrl: BlueMarker,
      popupAnchor: [0, -30],
      iconSize: new L.Point(26, 39),
      iconAnchor: [13, 39]
  });

  return (
    <Grid container spacing={2} >
      <Grid item xs={true} >
          <TextField
            variant="outlined" 
            id="name"
            disabled={disable}
            label="Dirección"
            name="name"
            error={!place.address}
            value={address}
            onChange={changeAddress}
            fullWidth
            placeholder="Av. Siempreviva 742"/>
      </Grid>
      <Grid item xs={'auto'}>
        <ThemeProvider theme={theme}>
          <LoadingButton
            style={{height: '100%'}}
            disabled={disable || !address || !address.trim() }                  
            loadingPosition="start"
            startIcon={<SearchIcon />}
            loading={searching}
            variant="contained"
            fullWidth
            onClick={searchAddress}>
            <b>Buscar</b>
          </LoadingButton>
        </ThemeProvider>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <MapContainer 
            style={{
              height: "400px",
              width: "100%",
              overflow: "hidden",
              zIndex: '399'
            }}
            center={location ? {lat: location.latitude, lng: location.longitude} : {lat: Constants.LATITUD_AYACUCHO, lng: Constants.LONGITUD_AYACUCHO}}
            zoom={14}
            scrollWheelZoom={false}
            whenCreated={setMap}>
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
            { location? 
              (<Marker
                draggable={!disable}
                icon={markerIcon}
                eventHandlers={markerEventHandlers}
                position={{lat: location.latitude, lng: location.longitude}}
                ref={markerRef}>
              </Marker>) : (null)
            }
          </MapContainer>
        </Card>
        <div style={{fontSize: '14px', width: '100%', textAlign: 'right'}}>
            * Puedes arrastra el marcador para indicar la ubicación del lugar
        </div>
      </Grid>
    </Grid>
  );
}
